"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    stage: "dev",
    dataStage: "dev",
    apiGateway: {
        url: "https://api-dev.photomaps.com",
    },
    contentUrl: "https://content-dev.photomaps.com",
    userContentUrl: "https://user-content-direct-dev.photomaps.com",
    userContentImageServerUrl: "https://user-content-dev.photomaps.com",
    staticUrl: "https://static-dev.photomaps.com",
    imageServerBucket: "mapmaker-user-content-dev",
    internalBucket: "mapmaker-internal-dev",
    walgreens: {
        production: false,
        apiKey: "DyvrlukqmWDQQW3XKGmqVKtHl6YFHejX",
        affiliateId: "THUNDERLAB",
        publisherId: "8972131",
    },
};
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJDb25maWcuZGV2LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL01hcG1ha2VyQ29uZmlnLmRldi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sTUFBTSxHQUFrQjtJQUM1QixLQUFLLEVBQUUsS0FBSztJQUNaLFNBQVMsRUFBRSxLQUFLO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLEdBQUcsRUFBRSwrQkFBK0I7S0FDckM7SUFDRCxVQUFVLEVBQUUsbUNBQW1DO0lBQy9DLGNBQWMsRUFBRSwrQ0FBK0M7SUFDL0QseUJBQXlCLEVBQUUsd0NBQXdDO0lBQ25FLFNBQVMsRUFBRSxrQ0FBa0M7SUFDN0MsaUJBQWlCLEVBQUUsMkJBQTJCO0lBQzlDLGNBQWMsRUFBRSx1QkFBdUI7SUFDdkMsU0FBUyxFQUFFO1FBQ1QsVUFBVSxFQUFFLEtBQUs7UUFDakIsTUFBTSxFQUFFLGtDQUFrQztRQUMxQyxXQUFXLEVBQUUsWUFBWTtRQUN6QixXQUFXLEVBQUUsU0FBUztLQUN2QjtDQUNGLENBQUM7QUFDRixrQkFBZSxNQUFNLENBQUMifQ==